module.exports = __webpack_public_path__ + "img/2.db9a8ee2.jpg";